import { getShortLinksReport } from "../api/shortlinksReportsApi";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";

export const useGetShortLinks = () => {
  const auth = useAuth();
  const { token, uid_partner } = auth.getSessionData() ?? {};

  return useQuery({
    queryKey: ["shortLinks", uid_partner],
    queryFn: async () =>
      getShortLinksReport({
        token,
        uid_partner,
      }),
    initialData: [],
    enabled: uid_partner !== undefined,
    refetchOnWindowFocus: false,
  });
};
